import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import {selectMyCoursesFiltered, selectDashboardStatus } from './dashboardSlice';
import { Page } from '../../ui';
import { selectHasRequiredLevel } from '../auth/authSlice';
import { CONTENT_STANDARD, media } from '../../utils/media';
import { STATUS_LOADING } from '../../utils/constants';
import { useTranslation } from 'react-i18next';
import PageControls from '../../ui/Page/PageControls';
import CreateYourFirstCourse from './components/CreateYourFirstCourse';
import OngoingCoursesList from './components/OngoingCoursesList';
import CompletedCoursesList from './components/CompletedCoursesList';
import DraftCoursesList from './components/DraftCoursesList';
import WelcomeMessage from './components/WelcomeMessage';
import { selectCartItemsCount } from '../webshop/cartSlice';
import SearchResults from './components/SearchResult';
import StatisticsWidget from './components/StatisticsWidget';
import EditableCoursesList from './components/EditableCoursesList';
import ListCourses from '../../components/ListCourses';

const HeaderSearch = styled.div`
  position: absolute;
  top: 8px;
  right: ${({$hasExtraMargem})=> !$hasExtraMargem ? '8px' : '64px'};
  z-index: 1200;
  ${media.greaterThan('laptop')} {
    right: 20px;
  }
`

const DashboardContent = ({openModal, clearSearch, searchQuery, handleSearch}) => {
  const { t } = useTranslation();

  const myCourses = useSelector(selectMyCoursesFiltered);
  const dashboardStatus = useSelector(selectDashboardStatus);
  const cartItemsCount = useSelector(selectCartItemsCount)
  const isOwner = useSelector((state) => selectHasRequiredLevel(state, 'owner'));
  
  return (
      <Page size={CONTENT_STANDARD} gap='60'>
        <HeaderSearch $hasExtraMargem={!!cartItemsCount}>
          <PageControls
            onClearSearch={clearSearch}
            onSearch={handleSearch}
            placeholder={t('dashboard.searchPlaceholder')}
            disableClear={!searchQuery}
          />
        </HeaderSearch>
        <WelcomeMessage />
        {isOwner && <StatisticsWidget />}
        {dashboardStatus === STATUS_LOADING && !myCourses.length ? <ListCourses isLoading={true} /> :
        !searchQuery.length ? <>
          {isOwner && !myCourses.length && <CreateYourFirstCourse openCreateCourseModal />}
          {isOwner && <DraftCoursesList  courses={myCourses} openModal={openModal} searchQuery={searchQuery} handleSearch={handleSearch} clearSearch={clearSearch}/>}
          {!!myCourses.length && <EditableCoursesList courses={myCourses}/>}
          {!!myCourses.length && <OngoingCoursesList courses={myCourses} searchQuery={searchQuery} handleSearch={handleSearch} clearSearch={clearSearch}/>}
          {!!myCourses.length && <CompletedCoursesList courses={myCourses} />}
        </> : <SearchResults courses={myCourses} />}
      </Page>  
  );
};

export default DashboardContent;
